import BaseComponent from "../components/BaseComponent";
import {
    Button,
    DateInput,
    Div,
    FormItem,
    LocaleProvider,
    Panel,
    Radio,
    RadioGroup,
    SplitCol,
    SplitLayout,
    View
} from "@vkontakte/vkui";

import MapSalePointsList from "../map/mapSalePointsList";
import BaseMap from "../map/BaseMap";
import CitiesMap from "../map/citiesMap";
import React from "react";
import {
    ACCESS_DENIED_MESSAGE,
    AdaptivityContext,
    isTradeDesigner,
    MODAL_STANDS_SHARE
} from "../assets/constants";
import SalePointsMapAutocomplete from "../map/SalePointsMapAutocomplete";
import { OfflineProvider } from "../contexts/OfflineContext";
import {Icon24DocumentOutline} from "@vkontakte/icons";
import SalePointsApi from "../api/references/salePoints";
import StandsShareModal from "../map/StandsShareModal";
import {STANDS_SHARE_MESSAGE} from "../map/standsShare";

class FragmentMap extends BaseComponent {


    constructor(props) {
        super(props)
        const state = {
            mapLevels: [
                {code: 'point', name: 'ТО'},
                {code: 'city', name: 'Города'},
                {code: 'region', name: 'Регионы'},
            ],
            map_current_level: {code: 'point', name: 'Точки'},
            map_date: new Date(),
            activePanelSalePointMap: "sale_point_map_main_panel",
            current_sale_point: null,
            standsShareTitle: '',
            standsShareStats: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
        this.mapRef = React.createRef()
    }

    receiveMessage = (event) => {
        if (event.data && event.data.type === STANDS_SHARE_MESSAGE) {
            this.setState({
                activeModal: MODAL_STANDS_SHARE,
                standsShareTitle: event.data.title || '',
                standsShareStats: event.data.groupTypeStats || null,
            })
        }
    }

    closeStandsShareModal = () => {
        this.setActiveModal(null)
        this.setState({standsShareTitle: '', standsShareStats: null})
    }

    handleAutocompleteSelect = (item) => {
        this.setCurrentSalePoint(item)

        if (this.mapRef.current && this.mapRef.current.centerOnPoint) {
            this.mapRef.current.centerOnPoint(item)
        }
    }

    render() {
        const isDesigner = isTradeDesigner(this.props.current_user)
        return <OfflineProvider>
            <View activePanel={this.state.activePanelSalePointMap}
                     >
            <Panel id="sale_point_map_main_panel">
                <SplitLayout modal={
                    <StandsShareModal activeModal={this.state.activeModal}
                                      title={this.state.standsShareTitle}
                                      groupTypeStats={this.state.standsShareStats}
                                      onClose={this.closeStandsShareModal}/>
                }>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    {isDesigner ? (
                        <SplitCol>
                            <Div style={{marginTop: 16}}>
                                <h3>{ACCESS_DENIED_MESSAGE}</h3>
                                <p>Раздел карты и отчётов мониторинга недоступен для роли Дизайнер.</p>
                            </Div>
                        </SplitCol>
                    ) : (
                        <>
                    {this.state.current_sale_point && this.state.current_sale_point.id > 0 &&
                        <SplitCol maxWidth={450}>
                            <Div _className="map-side-bar">
                                <Panel>
                                    <MapSalePointsList item={this.state.current_sale_point}
                                                       base_url={this.props.base_url}
                                                       current_user={this.props.current_user}
                                                       date={this.state.map_date}
                                    />
                                </Panel>
                            </Div>
                        </SplitCol>

                    }
                    <SplitCol>
                        <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>
                            <FormItem style={{maxWidth: '350px'}}>
                                <RadioGroup mode="horizontal">
                                    {this.state.mapLevels.map(lvl =>
                                        <Radio name="map_current_level" value={lvl.code}
                                               size={24}
                                               checked={lvl.code === this.state.map_current_level.code}
                                               onChange={() => this.setState({
                                                   current_sale_point: {id: -1},
                                                   map_current_level: lvl
                                               })}>
                                            {lvl.name}
                                        </Radio>)}
                                </RadioGroup>
                            </FormItem>
                            {this.state.map_current_level.code === 'point' && (
                                <SalePointsMapAutocomplete
                                    placeholder="Поиск ТЦ или торговой точки"
                                    style={{minWidth: '280px', flex: 1}}
                                    selectObject={this.handleAutocompleteSelect}
                                    numItems={5}
                                />
                            )}
                            {this.state.map_current_level.code === 'point' && (
                                <Button
                                    mode="outline"
                                    before={<Icon24DocumentOutline/>}
                                    onClick={() => this.openReport()}
                                    style={{marginLeft: '8px'}}
                                >
                                    Отчет XLS
                                </Button>
                            )}
                            <FormItem>

                                <LocaleProvider value={'ru'}>
                                    <DateInput
                                        value={this.state.map_date}
                                        onChange={v => this.setState({map_date: v})}

                                        closeOnChange


                                    />
                                </LocaleProvider>

                            </FormItem>
                        </div>
                        {this.state.map_current_level.code == 'point' &&
                            <BaseMap ref={this.mapRef}
                                     setCurrentSalePoint={this.setCurrentSalePoint}
                                     item={this.state.current_sale_point}
                                     date={this.state.map_date}
                            />}
                        {this.state.map_current_level.code == 'city' &&
                            <CitiesMap setCurrentSalePoint={this.setCurrentSalePoint}
                                       item={this.state.current_sale_point}
                                       date={this.state.map_date}
                            />}
                        {this.state.map_current_level.code == 'region' &&
                            <CitiesMap by_region
                                       setCurrentSalePoint={this.setCurrentSalePoint}
                                       item={this.state.current_sale_point}
                                       date={this.state.map_date}
                            />}

                    </SplitCol>
                        </>
                    )}

                </SplitLayout>

            </Panel>

        </View>
        </OfflineProvider>
    }

    setCurrentSalePoint = (item) => {
        this.setState({current_sale_point: item})
    }

    openReport = () => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({type: 'error', text: ACCESS_DENIED_MESSAGE, timeout: 3000})
            return
        }
        const url = SalePointsApi.getReportUrl(this.state.map_date)
        window.open(url, '_blank')
    }
}

export default FragmentMap
